export var textRowsWrapper = 'overflow-auto flex flex-row items-center';
export var paragraphWrapper = 'flex-1 pr-4 md:grid md:grid-cols-2 md:gap-4';
//# sourceMappingURL=stacked-list.styles.js.map